import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="19972" id="herói-quem-somos" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-background px-6 py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/software_texture_bg.png)] bg-cover bg-center opacity-10 mix-blend-overlay" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-transparent to-background/80" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <h1 className="font-sans text-4xl font-bold tracking-tight text-foreground md:text-5xl lg:text-[64px] lg:leading-tight">
          Inovação que Transforma o Varejo
        </h1>

        <p className="mt-6 max-w-2xl font-sans text-lg font-normal leading-[1.6] text-muted-foreground md:text-[20px]">
          A Linx Vila Velha combina 25 anos de experiência e tecnologia de ponta para entregar as melhores soluções de ERP e gestão para o seu negócio.
        </p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Button asChild className="group relative h-auto min-w-[200px] overflow-hidden rounded-lg border-2 border-primary bg-transparent px-8 py-4 text-sm font-bold uppercase tracking-widest text-foreground transition-all duration-400 ease-in-out hover:border-primary hover:bg-primary hover:text-primary-foreground hover:shadow-xl">
            <Link to="/AboutUsPage">
              <span className="relative z-10 flex items-center gap-2">
                Conheça Nossa História
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}